var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.616 1.616a1.25 1.25 0 0 1 1.768 0l3.328 2.8c.616.518.923.777 1.288.777s.672-.259 1.288-.776l3.328-2.8a1.25 1.25 0 0 1 1.768 1.767l-2.8 3.328c-.518.616-.777.923-.777 1.288s.259.672.776 1.288l2.8 3.328a1.25 1.25 0 0 1-1.767 1.768l-3.328-2.8c-.616-.518-.923-.777-1.288-.777s-.672.259-1.288.776l-3.328 2.8a1.25 1.25 0 0 1-1.768-1.767l2.8-3.328c.518-.616.777-.923.777-1.288s-.259-.672-.776-1.288l-2.8-3.328a1.25 1.25 0 0 1 0-1.768Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose16);
export default __webpack_public_path__ + "static/media/close_16.f76b9825.svg";
export { ForwardRef as ReactComponent };